export default __webpack_public_path__ + "static/media/instagramIcon.09c5f1eb.svg";